import {reactive} from "vue";

const sidenav = {
    data: reactive({
        active: false
    }),
    toggle() {
        this.data.active = !this.data.active;
    }
};

export default sidenav;
